import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Box } from '@hivebrite/design-system/Box';
import { ButtonInLink } from '@hivebrite/design-system/ButtonInLink';
import { Card } from '@hivebrite/design-system/Card';
import { Divider } from '@hivebrite/design-system/Divider';
import { Loader } from '@hivebrite/design-system/Loader';

import Sidebar from 'hb-react/shared/apps/Memberships/components/Sidebar';
import { CART_STATUS } from 'hb-react/shared/components/ShoppingCard/constants/cartConstants';
import { useShoppingCard } from 'hb-react/shared/components/ShoppingCard/hooks/useShoppingCard';

import { PaymentGateway } from './Gateway';
import Layout from '../PurchaseMembership/components/Layout';

const Payment = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useShoppingCard();

  const queryClient = useQueryClient();
  const {
    cart: { cart_items: cartItems, status },
  } = data;

  const onSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: ['memberships'],
    });
    navigate('../completed');
  };

  useEffect(() => {
    if (status === CART_STATUS.PAID) {
      onSuccess();
    }
  }, [status]);

  if (isLoading || status === CART_STATUS.PAID) {
    return <Loader />;
  }

  const memberships = cartItems
    .filter(({ membership_type: type }) => !!type)
    .map(({ membership_type: membership }) => membership);

  return (
    <Layout
      orderSummaryOnTop
      navigation={[
        {
          label: __('Registration'),
          disable: true,
        },
        {
          label: __('Billing Information'),
          disable: true,
        },
        {
          label: __('Payment'),
          active: true,
          requiredExplanation: true,
        },
      ]}
      sidebar={
        <Sidebar
          cartItems={cartItems}
          memberships={memberships}
          topBoundary="header"
          offset="25px"
        />
      }
    >
      <Box display="block">
        <Card width="100%">
          <Box font="h3-semibold">{__('Payment details')}</Box>
          <Divider mt={3} width="100%" />
          <PaymentGateway onSuccess={onSuccess} />
        </Card>
        <NavBar />
      </Box>
    </Layout>
  );
};

const NavBar = () => (
  <Box mt={6}>
    <ButtonInLink
      linkProps={{
        to: '..',
      }}
      variant="secondary"
    >
      {s__('Memberships|Go back to registration')}
    </ButtonInLink>
  </Box>
);

export default Payment;
